export default (props, vars) => props?.['status'] === 'ACCEPTED';
